import request from '@/utils/request'

export function getNotice(params, isNotify) {
  return request({
    url: '/api/getNotice',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
export function getNoticeDetail(params, isNotify) {
  return request({
    url: '/api/getNoticeDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function saveNotice(param, isNotify) {
  return request({
    url: '/api/saveNotice',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteNotice(param, isNotify) {
  return request({
    url: '/api/deleteNotice',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}

export function getNoticeReport(param, isNotify) {
  let responseType = 'blob'
  return request({
    url: '/api/getNoticeReport',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' },
    responseType: responseType
  })
}